<template>
  <div class="nav-wrapper">
    <ul v-if="menuInfo.company" class="nav nav-table">
      <li class="select-nav"><a @click="changeView('company', menuInfo.company)">{{ menuInfo.company.name }}</a></li>
    </ul>
    <ul v-else-if="menuInfo.division" class="nav nav-table">
      <li><a @click="changeView('company', menuInfo.division)">{{ menuInfo.division.pName ? menuInfo.division.pName : menuInfo.division.companyName }}</a></li>
      <li><p><img src="/static/img/ico-arrow-line-S-gray@2x.png" alt=""></p></li>
      <li class="select-nav"><a @click="changeView('division', menuInfo.division)">{{ menuInfo.division.name ? menuInfo.division.name : menuInfo.division.divisionName }}</a></li>
    </ul>
    <ul v-else-if="menuInfo.device" class="nav nav-table">
      <li><a @click="changeView('company', menuInfo.device)">{{ menuInfo.device.Pname ?  menuInfo.device.Pname : menuInfo.device.companyName }}</a></li>
      <li><p><img src="/static/img/ico-arrow-line-S-gray@2x.png" alt=""></p></li>
      <li class="select-nav"><a @click="changeView('device', menuInfo.device)">{{ menuInfo.device.name ? menuInfo.device.name : menuInfo.device.deviceName }}</a></li>
    </ul>
    <ul v-else-if="menuInfo.tray" class="nav nav-table">
      <li><a @click="changeView('company', menuInfo.tray)">{{ menuInfo.tray.companyName }}</a></li>
      <li><p><img src="/static/img/ico-arrow-line-S-gray@2x.png" alt=""></p></li>
      <li><a @click="changeView('device', menuInfo.tray)">{{ menuInfo.tray.deviceName }}</a></li>
      <li><p><img src="/static/img/ico-arrow-line-S-gray@2x.png" alt=""></p></li>
      <li class="select-nav"><a @click="changeView('tray', menuInfo.tray)">{{ menuInfo.tray.name }}</a></li>
    </ul>
  </div>
</template>

<script>
/* eslint-disable no-console */
/* eslint-disable no-alert */
/* eslint-disable no-plusplus */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-continue */

import Configuration from '@/js/Configuration';
import UpdateModal from '@/components/account/UpdateModal';

export default {
  props: [
    'menuInfo',
  ],
  components: {
    UpdateModal,
  },
  data: () => ({
    uID: null,
    userID: null,
    modal: false,
    user: {
      uID: null,
      userID: null,
      name: null,
      role: null,
      passwd: null,
      manager: null,
      operator: null,
      monitor: null,
    },
  }),
  created() {
    if (this.$cookie.get('accessToken')) {
      const token = this.$jwtDecode(this.$cookie.get('accessToken'));
      this.userID = token.userID;
      this.uID = token.uID;
    }
  },
  methods: {
    goMenu(menuName) {
      this.$router.push({ name: menuName }).catch(() => {});
    },
    async logout() {
      try {
        const res = await this.$http.put(
          `${Configuration.value(
            'CPAYMENT_ADDRESS',
          )}/api/v1/cpayment/user/logout/${this.uID}`,
          {
            userID: this.userID,
          },
          {
            headers: {
              Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
            },
          },
        );
        if (res.status !== 200) {
          throw new Error(`Response status is "${res.status}"`);
        }
        if (res.data.resultCode !== '0000') {
          throw new Error(`ResultCode is "${res.data.resultCode}"`);
        }
      } catch (e) {
        alert('로그아웃에 실패하였습니다.');
        console.error(e);
      }

      //
      this.$deleteCookie();
      this.$router.push({ name: 'Login' });
    },
    async updateUser() {
      try {
        const role = this.$jwtDecode(this.$cookie.get('accessToken')).role;
        if (role === 0 || role === 1) return;

        const getURL = `${Configuration.value(
          'CACCOUNT_ADDRESS',
        )}/api/v1/caccount/user/${this.uID}`;

        const result = await this.$http.get(getURL, {
          headers: {
            Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
          },
        });
        if (result.status !== 200) {
          throw new Error(`Response status is "${result.status}"`);
        }
        if (result.data.resultCode !== '0000') {
          throw new Error(`ResultCode is "${result.data.resultCode}"`);
        }

        this.user.uID = result.data.user.uID;
        this.user.userID = result.data.user.userID;
        this.user.name = result.data.user.name;
        this.user.role = result.data.user.role;
        this.user.email = result.data.user.email;
        this.user.mobile = result.data.user.mobile;
        this.user.manager = result.data.user.manager;
        this.user.operator = result.data.user.operator;
        this.user.monitor = result.data.user.monitor;
        this.modal = true;
      } catch (e) {
        console.error(e);
      }
    },
    closeModal() {
      this.modal = false;
    },
    reloadData() {
      this.modal = false;
    },
    changeView(type, object) {
      this.$emit('selectNode', object, type, 1);
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/include/ContentsNavigation.vue